import { render, staticRenderFns } from "./HorizontalCategory.vue?vue&type=template&id=9e32a35c&scoped=true&"
import script from "./HorizontalCategory.vue?vue&type=script&lang=js&"
export * from "./HorizontalCategory.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalCategory.vue?vue&type=style&index=0&id=9e32a35c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e32a35c",
  null
  
)

export default component.exports